module.exports = require("@mdn/browser-compat-data");